import React, { useEffect, useState } from "react";
import Bookingnavbar from "../components/Bookingnavbar";
import timeicon from "../assets/ttime.svg";
import calendericon from "../assets/tcalendar.svg";
import locationicon from "../assets/tlocation.svg";
import profileimg from "../assets/workerimg.png";
import { Link, useNavigate } from "react-router-dom";
import { auth, db, ref } from "../utilities/firebaseConfig";
import { get, off, onValue } from "firebase/database";

function Mytaskpage() {
  const [selectedNav, setSelectedNav] = useState("");
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen to authentication state changes
    const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setJobs([]);
        setLoading(false);
        return;
      }

      const jobsRef = ref(db, "jobs");

      // Fetch jobs only after user is authenticated
      const unsubscribeJobs = onValue(jobsRef, async (snapshot) => {
        if (!snapshot.exists()) {
          setJobs([]);
          setLoading(false);
          return;
        }

        const jobsData = Object.entries(snapshot.val()).map(([id, job]) => ({
          id,
          ...job,
        }));

        const myJobs = jobsData.filter((job) => job.userId === user.uid);

        // Only collect unique technicianIds
        const techIdSet = new Set();
        myJobs.forEach((job) => {
          if (job.technicianId) techIdSet.add(job.technicianId);
        });

        // Fetch all technicians in one go
        const techniciansRef = ref(db, "technicians");
        const techSnap = await get(techniciansRef);
        const allTechnicians = techSnap.exists() ? techSnap.val() : {};

        // Build job list with attached technician details
        const jobsWithTech = myJobs.map((job) => ({
          ...job,
          technician: allTechnicians[job.technicianId] || null,
        }));

        setJobs(jobsWithTech);
        setLoading(false);
      });

      // Cleanup when component unmounts or when auth changes
      return () => {
        unsubscribeJobs();
      };
    });

    // Cleanup the authentication listener
    return () => unsubscribeAuth();
  }, []);

  // Format date
  function formatDate(dateString) {
    const date = new Date(dateString);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${days[date.getDay()]}, ${months[date.getMonth()]} ${String(
      date.getDate()
    ).padStart(2, "0")}, ${date.getFullYear()}`;
  }

  // Categorized job filters
  const scheduledJobs = jobs.filter((job) => job.status === "scheduled");
  const pendingJobs = jobs.filter(
    (job) => job.status === "awaiting technician's approval"
  );
  const activeJobs = jobs.filter((job) => job.status === "accepted");
  const inProgressJobs = jobs.filter((job) => job.status === "in progress");
  const completedJobs = jobs.filter((job) => job.status === "completed");
  const rejectedJobs = jobs.filter((job) => job.status === "rejected");
  const cancelledJobs = jobs.filter((job) => job.status === "cancelled");

  return (
    <div className='mytcnt'>
      <Bookingnavbar />

      <div className='bookingpagecnt'>
        <div className='thebiggap'></div>
        <h1 className='mytaskcnttitle'>My Tasks</h1>
        <div className='mytasknav'>
          <button
            onClick={() => setSelectedNav("accepted")}
            className={
              selectedNav === "accepted"
                ? "mytasknav-btn mytactive"
                : "mytasknav-btn"
            }
          >
            Accepted
          </button>{" "}
          <button
            onClick={() => setSelectedNav("completed")}
            className={
              selectedNav === "completed"
                ? "mytasknav-btn mytactive"
                : "mytasknav-btn"
            }
          >
            Completed
          </button>
          <button
            onClick={() => setSelectedNav("in progress")}
            className={
              selectedNav === "in progress"
                ? "mytasknav-btn mytactive"
                : "mytasknav-btn"
            }
          >
            In progress
          </button>
          <button
            onClick={() => setSelectedNav("pending")}
            className={
              selectedNav === "pending"
                ? "mytasknav-btn mytactive"
                : "mytasknav-btn"
            }
          >
            Pending
          </button>
          <button
            onClick={() => setSelectedNav("rejected")}
            className={
              selectedNav === "rejected"
                ? "mytasknav-btn mytactive"
                : "mytasknav-btn"
            }
          >
            Rejected
          </button>
          <button
            onClick={() => setSelectedNav("scheduled")}
            className={
              selectedNav === "scheduled"
                ? "mytasknav-btn mytactive"
                : "mytasknav-btn"
            }
          >
            Scheduled
          </button>
          <button
            onClick={() => setSelectedNav("cancelled")}
            className={
              selectedNav === "cancelled"
                ? "mytasknav-btn mytactive"
                : "mytasknav-btn"
            }
          >
            Cancelled
          </button>
        </div>
        <div className='thebiggap'></div>

        {selectedNav === "scheduled" && (
          <>
            {scheduledJobs.length > 0 ? (
              scheduledJobs.map((job) => (
                <div key={job.id} className='activetaskcnttop taskschedule'>
                  <div className='activetaskcnt '>
                    <div className='activetaskcntleft'>
                      <p className='actjobtitle'>{job.title}</p>
                      <div className='thegap'></div>
                      <div className='btsdetitemm'>
                        <img
                          src={calendericon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {formatDate(job.scheduledDate)}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          No 25, Idunlami St Lagos. Nigeria
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img src={timeicon} alt='' className='btsdeticonn' />
                        <label htmlFor='' className='btsdettlabell'>
                          9:30 Am. 1hr
                        </label>
                      </div>
                    </div>
                    {job.technician && (
                      <div className='mytaskcntitem-rightt'>
                        <img
                          src={profileimg}
                          alt=''
                          className='activetaskimgg'
                        />
                        <h1 className='activetasknamee'>
                          {job.technician.fullName}
                        </h1>
                        <div
                          className={
                            5.5 > 3.5 ? "wlitoprgreen" : "wlitopryellow"
                          }
                        >
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 15 15'
                            fill='#fff'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                              fill='#fff'
                            ></path>
                          </svg>
                          <p className='ratingnum'>4.5</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='thegap'></div>
                  <button
                    className='mytaskviewtbtnn'
                    onClick={() => navigate(`/job/${job.id}`)}
                  >
                    View Details
                  </button>
                </div>
              ))
            ) : (
              <p>No scheduled jobs.</p>
            )}
          </>
        )}

        {selectedNav === "pending" && (
          <>
            {pendingJobs.length > 0 ? (
              pendingJobs.map((job) => (
                <div key={job.id} className='activetaskcnttop taskpending'>
                  <div className='activetaskcnt '>
                    <div className='activetaskcntleft'>
                      <p className='actjobtitle'>{job.title}</p>
                      <div className='thegap'></div>
                      <div className='btsdetitemm'>
                        <img
                          src={calendericon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {formatDate(job.scheduledDate)}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.address}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img src={timeicon} alt='' className='btsdeticonn' />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.timeOfDay} 1hr
                        </label>
                      </div>
                    </div>
                    {job.technician && (
                      <div className='mytaskcntitem-rightt'>
                        <img
                          src={job.technician.profileUrl}
                          alt=''
                          className='activetaskimgg'
                        />
                        <h1 className='activetasknamee'>
                          {job.technician.fullName}
                        </h1>
                        <div
                          className={
                            job.technician.rating > 3.5
                              ? "wlitoprgreen"
                              : "wlitopryellow"
                          }
                        >
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 15 15'
                            fill='#fff'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                              fill='#fff'
                            ></path>
                          </svg>
                          <p className='ratingnum'>{job.technician.rating}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='thegap'></div>
                  <button
                    className='mytaskviewtbtnn'
                    onClick={() => navigate(`/job/${job.id}`)}
                  >
                    View Details
                  </button>
                </div>
              ))
            ) : (
              <p>No pending jobs.</p>
            )}
          </>
        )}

        {selectedNav === "accepted" && (
          <>
            {activeJobs.length > 0 ? (
              activeJobs.map((job) => (
                <div key={job.id} className='activetaskcnttop taskschedule'>
                  <div className='activetaskcnt '>
                    <div className='activetaskcntleft'>
                      <p className='actjobtitle'>{job.title}</p>
                      <div className='thegap'></div>
                      <div className='btsdetitemm'>
                        <img
                          src={calendericon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {formatDate(job.scheduledDate)}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          No 25, Idunlami St Lagos. Nigeria
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img src={timeicon} alt='' className='btsdeticonn' />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.timeOfDay} 1hr
                        </label>
                      </div>
                    </div>
                    {job.technician && (
                      <div className='mytaskcntitem-rightt'>
                        <img
                          src={job.technician.profileUrl}
                          alt=''
                          className='activetaskimgg'
                        />
                        <h1 className='activetasknamee'>
                          {job.technician.fullName}
                        </h1>
                        <div
                          className={
                            job.technician.rating > 3.5
                              ? "wlitoprgreen"
                              : "wlitopryellow"
                          }
                        >
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 15 15'
                            fill='#fff'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                              fill='#fff'
                            ></path>
                          </svg>
                          <p className='ratingnum'>{job.technician.rating}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='thegap'></div>
                  <button
                    className='mytaskviewtbtnn'
                    onClick={() => navigate(`/client/job/${job.id}`)}
                  >
                    View Details
                  </button>
                </div>
              ))
            ) : (
              <p>No active jobs.</p>
            )}
          </>
        )}

        {selectedNav === "completed" && (
          <>
            {completedJobs.length > 0 ? (
              completedJobs.map((job) => (
                <div key={job.id} className='activetaskcnttop taskinprogress'>
                  <div className='activetaskcnt '>
                    <div className='activetaskcntleft'>
                      <p className='actjobtitle'>{job.title}</p>
                      <div className='thegap'></div>
                      <div className='btsdetitemm'>
                        <img
                          src={calendericon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {formatDate(job.scheduledDate)}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.address}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img src={timeicon} alt='' className='btsdeticonn' />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.timeOfDay} {job.totalTimeInHours}
                        </label>
                      </div>
                    </div>
                    {job.technician && (
                      <div className='mytaskcntitem-rightt'>
                        <img
                          src={job.technician.profileUrl}
                          alt=''
                          className='activetaskimgg'
                        />
                        <h1 className='activetasknamee'>
                          {job.technician.fullName}
                        </h1>
                        <div
                          className={
                            job.technician.rating > 3.5
                              ? "wlitoprgreen"
                              : "wlitopryellow"
                          }
                        >
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 15 15'
                            fill='#fff'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                              fill='#fff'
                            ></path>
                          </svg>
                          <p className='ratingnum'>{job.technician.rating}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='thegap'></div>
                  <button
                    className='mytaskviewtbtnn'
                    onClick={() => navigate(`/client/job/${job.id}`)}
                  >
                    View
                  </button>
                </div>
              ))
            ) : (
              <p>No completed jobs.</p>
            )}
          </>
        )}

        {selectedNav === "in progress" && (
          <>
            {inProgressJobs.length > 0 ? (
              inProgressJobs.map((job) => (
                <div key={job.id} className='activetaskcnttop taskinprogress'>
                  <div className='activetaskcnt '>
                    <div className='activetaskcntleft'>
                      <p className='actjobtitle'>{job.title}</p>
                      <div className='thegap'></div>
                      <div className='btsdetitemm'>
                        <img
                          src={calendericon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {formatDate(job.scheduledDate)}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.address}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img src={timeicon} alt='' className='btsdeticonn' />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.timeOfDay} 1hr
                        </label>
                      </div>
                    </div>
                    {job.technician && (
                      <div className='mytaskcntitem-rightt'>
                        <img
                          src={job.technician.profileUrl}
                          alt=''
                          className='activetaskimgg'
                        />
                        <h1 className='activetasknamee'>
                          {job.technician.fullName}
                        </h1>
                        <div
                          className={
                            job.technician.rating > 3.5
                              ? "wlitoprgreen"
                              : "wlitopryellow"
                          }
                        >
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 15 15'
                            fill='#fff'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                              fill='#fff'
                            ></path>
                          </svg>
                          <p className='ratingnum'>{job.technician.rating}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='thegap'></div>
                  <button
                    className='mytaskviewtbtnn'
                    onClick={() => navigate(`/client/job/${job.id}`)}
                  >
                    View Details
                  </button>
                </div>
              ))
            ) : (
              <p>No in progress jobs.</p>
            )}
          </>
        )}

        {selectedNav === "rejected" && (
          <>
            {rejectedJobs.length > 0 ? (
              rejectedJobs.map((job) => (
                <div key={job.id} className='activetaskcnttop taskrejected'>
                  <div className='activetaskcnt '>
                    <div className='activetaskcntleft'>
                      <p className='actjobtitle'>{job.title}</p>
                      <div className='thegap'></div>
                      <div className='btsdetitemm'>
                        <img
                          src={calendericon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {formatDate(job.scheduledDate)}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          No 25, Idunlami St Lagos. Nigeria
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img src={timeicon} alt='' className='btsdeticonn' />
                        <label htmlFor='' className='btsdettlabell'>
                          9:30 Am. 1hr
                        </label>
                      </div>
                    </div>
                    {job.technician && (
                      <div className='mytaskcntitem-rightt'>
                        <img
                          src={profileimg}
                          alt=''
                          className='activetaskimgg'
                        />
                        <h1 className='activetasknamee'>
                          {job.technician.fullName}
                        </h1>
                        <div
                          className={
                            5.5 > 3.5 ? "wlitoprgreen" : "wlitopryellow"
                          }
                        >
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 15 15'
                            fill='#fff'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                              fill='#fff'
                            ></path>
                          </svg>
                          <p className='ratingnum'>4.5</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='thegap'></div>
                  <div className='thesepbtn'>
                    <button
                      className='mytaskviewtbtnn'
                      onClick={() => navigate(`/job/${job.id}`)}
                    >
                      View Details
                    </button>
                    <button className='mytaskviewbtnrepost'>Repost Task</button>
                  </div>
                </div>
              ))
            ) : (
              <p>No rejected jobs.</p>
            )}
          </>
        )}
        {selectedNav === "cancelled" && (
          <>
            {cancelledJobs.length > 0 ? (
              cancelledJobs.map((job) => (
                <div key={job.id} className='activetaskcnttop taskrejected'>
                  <div className='activetaskcnt '>
                    <div className='activetaskcntleft'>
                      <p className='actjobtitle'>{job.title}</p>
                      <div className='thegap'></div>
                      <div className='btsdetitemm'>
                        <img
                          src={calendericon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {formatDate(job.scheduledDate)}
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          No 25, Idunlami St Lagos. Nigeria
                        </label>
                      </div>
                      <div className='btsdetitemm'>
                        <img src={timeicon} alt='' className='btsdeticonn' />
                        <label htmlFor='' className='btsdettlabell'>
                          9:30 Am. 1hr
                        </label>
                      </div>
                    </div>
                    {job.technician && (
                      <div className='mytaskcntitem-rightt'>
                        <img
                          src={profileimg}
                          alt=''
                          className='activetaskimgg'
                        />
                        <h1 className='activetasknamee'>
                          {job.technician.fullName}
                        </h1>
                        <div
                          className={
                            5.5 > 3.5 ? "wlitoprgreen" : "wlitopryellow"
                          }
                        >
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 15 15'
                            fill='#fff'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                              fill='#fff'
                            ></path>
                          </svg>
                          <p className='ratingnum'>4.5</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='thegap'></div>
                  <div className='thesepbtn'>
                    <button
                      className='mytaskviewtbtnn'
                      onClick={() => navigate(`/job/${job.id}`)}
                    >
                      View Details
                    </button>
                    <button className='mytaskviewbtnrepost'>Repost Task</button>
                  </div>
                </div>
              ))
            ) : (
              <p>No rejected jobs.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Mytaskpage;
